import { getErrorDescription, ErrorType } from '@/shared/types/error-type'

export const resolveSuspenseErrorMessage = (err: unknown): string => {
  const message = err instanceof Error ? err.message : String(err)
  if (message in ErrorType) {
    return getErrorDescription(message as ErrorType)
  }
  return message || 'Unknown error'
}
